import { v4 as uuidv4 } from 'uuid';
import { SignJWT } from 'jose';
import { certObfuscation } from 'constants/certObfuscation';

const base64StringToUint8Array = (base64: string): Uint8Array => {
  const binaryString = atob(base64);
  const bytes = new Uint8Array(binaryString.length);

  for (let i = 0; i < binaryString.length; i += 1) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  return bytes;
};

export const generateSignedJwt = async (
  signingCert: string,
  tenantId: string,
  deviceId: string
): Promise<string> => {
  const rawCert = signingCert.substr(
    0,
    signingCert.length - certObfuscation.length
  );
  const keyData = base64StringToUint8Array(rawCert);

  const cryptoKey = await crypto.subtle.importKey(
    'raw',
    keyData,
    {
      name: 'HMAC',
      hash: 'SHA-256',
    },
    false,
    ['sign']
  );

  const now = Math.floor(Date.now() / 1000);

  return new SignJWT({
    tokenType: 'arrival-display',
    tenantId,
    iat: now,
    exp: now + 60 * 30,
  })
    .setSubject(deviceId)
    .setIssuer('robin-arrival-display')
    .setAudience('robinpowered.com')
    .setJti(uuidv4())
    .setProtectedHeader({ alg: 'HS256' })
    .sign(cryptoKey);
};
